import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentStatusDialogComponent } from './payment-status-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    PaymentStatusDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    PaymentStatusDialogComponent
  ]
})
export class PaymentStatusDialogModule { }
